import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75566c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = { class: "my-4 mx-4 p-0 bg-white border-radius-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "font-grey p-cursor text-center" }, [
      /*#__PURE__*/_createElementVNode("b", { style: {"color":"#6B7A99"} }, "Account Debit Form")
    ])
  ])
], -1))
const _hoisted_7 = { class: "row my-3 justify-content-center" }
const _hoisted_8 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_9 = { class: "container-fluid" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "list-unstyled multi-steps" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Account Information", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Beneficiary Information", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Payment Details", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "E-Signature", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Upload Proof", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "row my-3 justify-content-center" }
const _hoisted_24 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_25 = { class: "login-card" }
const _hoisted_26 = { class: "login-body personal" }
const _hoisted_27 = { class: "row mt-3" }
const _hoisted_28 = { class: "col-md-12 col-12" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Caprock Account Holder", -1))
const _hoisted_31 = { class: "col-md-12 col-12" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Select Account", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Ac Type", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Cash Account", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Securities", -1))
const _hoisted_37 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Select account to debit", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Cash Account", -1))
const _hoisted_41 = ["ref_no", "value"]
const _hoisted_42 = {
  key: 1,
  class: "col-md-12 col-12"
}
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Select account to debit", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Securities Account", -1))
const _hoisted_46 = ["ref_no", "value"]
const _hoisted_47 = { class: "col-md-12 col-12" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Caprock Account Ref No.", -1))
const _hoisted_50 = { class: "col-md-12 col-12" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Reason for payment", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Payment Reason", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "service" }, "Service", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "capital_transfer" }, "Capital Transfer", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "purchase" }, "Purchase", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "direction_to_pay" }, "Direction to Pay ", -1))
const _hoisted_58 = { class: "col-md-12 col-12" }
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Upload proof of Transaction", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = ["src"]
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = { style: {"margin-left":"10px"} }
const _hoisted_66 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_67 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_68 = { class: "col-3 px-1" }
const _hoisted_69 = { class: "col-3 px-1" }
const _hoisted_70 = { class: "col-3 px-1" }
const _hoisted_71 = { class: "row my-3 justify-content-center" }
const _hoisted_72 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_73 = { class: "login-card" }
const _hoisted_74 = { class: "login-body personal" }
const _hoisted_75 = { class: "row mt-3" }
const _hoisted_76 = { class: "col-md-12 col-12" }
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Beneficiary Type", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select beneficiary type", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "own" }, "Transfer to my own account", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "existing" }, "Existing Beneficiary", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "new" }, "New Beneficiary", -1))
const _hoisted_83 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_84 = { class: "form-group" }
const _hoisted_85 = { class: "font-grey" }
const _hoisted_86 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "35px",
  height: "35px",
  version: "1.1",
  viewBox: "0 0 35 35",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  style: {"shape-rendering":"geometricprecision","text-rendering":"geometricprecision","fill-rule":"evenodd","clip-rule":"evenodd","margin":"0px 0px 0px 25px"}
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { id: "Layer_x0020_1" }, [
  /*#__PURE__*/_createElementVNode("metadata", { id: "CorelCorpID_0Corel-Layer" }),
  /*#__PURE__*/_createElementVNode("g", { id: "_863461543616" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "fil0",
      d: "M17.49 2.83l0 0c8.46,0 15.32,6.86 15.32,15.32l0 0c0,8.46 -6.86,15.32 -15.32,15.32l0 0c-8.46,0 -15.32,-6.86 -15.32,-15.32l0 0c0,-8.46 6.86,-15.32 15.32,-15.32z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", { id: "_863458324208" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "fil1",
      d: "M22.5 23.87l-10.01 0c-0.4,0 -0.72,-0.33 -0.72,-0.72 0,0 0,0 0,0l0 -0.71c0,-0.59 0.37,-1.44 2.15,-2.15 1.14,-0.44 2.35,-0.69 3.57,-0.72 1.23,0.03 2.44,0.28 3.58,0.72 1.77,0.71 2.14,1.56 2.14,2.15l0 0.71c0,0 0,0 0,0 0,0.4 -0.32,0.72 -0.71,0.72 0,0 0,0 0,0l0 0zm-5.01 -5.72c-1.58,0 -2.86,-1.28 -2.86,-2.86 0,-1.58 1.28,-2.86 2.86,-2.86 1.58,0 2.86,1.28 2.86,2.86 0,1.57 -1.28,2.85 -2.86,2.86l0 0z"
    })
  ])
], -1))
const _hoisted_89 = [
  _hoisted_87,
  _hoisted_88
]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { style: {"font-weight":"800"} }, "View beneficiary detail", -1))
const _hoisted_91 = {
  key: 1,
  class: "col-md-12 col-12"
}
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, " Select external bank Account ", -1))
const _hoisted_94 = {
  key: 2,
  class: "col-md-12 col-12"
}
const _hoisted_95 = { class: "form-group" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Corporate or Individual", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select type", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "corporate" }, "Corporate", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "individual" }, "Individual", -1))
const _hoisted_100 = {
  key: 3,
  class: "col-md-12 col-12"
}
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name of beneficiary", -1))
const _hoisted_103 = {
  key: 4,
  class: "col-md-12 col-12"
}
const _hoisted_104 = { class: "form-group" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company registration number of beneficiary", -1))
const _hoisted_106 = {
  key: 5,
  class: "col-md-12 col-12"
}
const _hoisted_107 = { class: "form-group" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Country of residency of Beneficiary", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Country", -1))
const _hoisted_110 = ["value"]
const _hoisted_111 = {
  key: 6,
  class: "col-md-12 col-12"
}
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Country of registration of Beneficiary", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select your ountry", -1))
const _hoisted_115 = ["value"]
const _hoisted_116 = {
  key: 7,
  class: "col-md-12 col-12"
}
const _hoisted_117 = { class: "form-group" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Structure of Beneficiary", -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "public" }, "Public", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "private" }, "Private", -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "partnership" }, "Partnership", -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "individual" }, "Individual", -1))
const _hoisted_124 = {
  key: 8,
  class: "col-md-12 col-12"
}
const _hoisted_125 = { class: "form-group" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name of person making payment", -1))
const _hoisted_127 = {
  key: 9,
  class: "col-md-12 col-12"
}
const _hoisted_128 = { class: "form-group" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Passport number of beneficiary", -1))
const _hoisted_130 = {
  key: 10,
  class: "col-md-12 col-12"
}
const _hoisted_131 = { class: "form-group" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Passport expiry of beneficiary", -1))
const _hoisted_133 = {
  key: 11,
  class: "col-md-12 col-12"
}
const _hoisted_134 = { class: "form-group" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Country of of issue of passport of beneficiary", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select your country", -1))
const _hoisted_137 = ["value"]
const _hoisted_138 = {
  key: 12,
  class: "col-md-12 col-12"
}
const _hoisted_139 = { class: "form-group" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Date of Birth of Beneficiary", -1))
const _hoisted_141 = {
  key: 13,
  class: "col-md-12 col-12"
}
const _hoisted_142 = { class: "form-group" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Home address of Beneficiary", -1))
const _hoisted_144 = { class: "form-group place_suggest d-none" }
const _hoisted_145 = {
  class: "card place_suggest",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_146 = ["onClick"]
const _hoisted_147 = ["id"]
const _hoisted_148 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_149 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_151 = {
  key: 14,
  class: "col-md-12 col-12"
}
const _hoisted_152 = { class: "form-group" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email address of Beneficiary", -1))
const _hoisted_154 = {
  key: 15,
  class: "col-md-12 col-12"
}
const _hoisted_155 = { class: "form-group" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Mobile/Cell Number of Beneficiary", -1))
const _hoisted_157 = {
  key: 16,
  class: "col-md-12 col-12"
}
const _hoisted_158 = { class: "form-group" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Beneficiary a trust ?", -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "beneficiary_trust0"
}, " Yes ", -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "beneficiary_trust1"
}, " No ", -1))
const _hoisted_163 = {
  key: 17,
  class: "col-md-12 col-12"
}
const _hoisted_164 = { class: "form-group" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Upload trust deed", -1))
const _hoisted_166 = ["src"]
const _hoisted_167 = ["innerHTML"]
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_169 = { style: {"margin-left":"10px"} }
const _hoisted_170 = {
  key: 18,
  class: "col-md-12 col-12"
}
const _hoisted_171 = { class: "form-group" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Beneficiary a USA citizen ?", -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "usa_citizen0"
}, " Yes ", -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "usa_citizen1"
}, " No ", -1))
const _hoisted_176 = {
  key: 19,
  class: "col-md-12 col-12"
}
const _hoisted_177 = { class: "form-group" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "If USA citizen or tax resident of USA is marked Yes, kindly provide social security number of Beneficiary", -1))
const _hoisted_179 = {
  key: 20,
  class: "col-md-12 col-12"
}
const _hoisted_180 = { class: "form-group" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Beneficiary a tax resident of the USA ?", -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "beneficiary_tax_resident_usa0"
}, " Yes ", -1))
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "beneficiary_tax_resident_usa1"
}, " No ", -1))
const _hoisted_185 = {
  key: 21,
  class: "col-12"
}
const _hoisted_186 = { class: "form-group" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Beneficiary Tax ID", -1))
const _hoisted_188 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_189 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_190 = { class: "col-3 px-1" }
const _hoisted_191 = { class: "col-3 px-1" }
const _hoisted_192 = { class: "col-3 px-1" }
const _hoisted_193 = { class: "row my-3 justify-content-center" }
const _hoisted_194 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_195 = { class: "login-card" }
const _hoisted_196 = { class: "login-body personal" }
const _hoisted_197 = { class: "row mt-3" }
const _hoisted_198 = { class: "col-md-12 col-12" }
const _hoisted_199 = { class: "form-group" }
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Payment Amount", -1))
const _hoisted_201 = { class: "col-md-12 col-12" }
const _hoisted_202 = { class: "form-group" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Payment Currency", -1))
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select currency", -1))
const _hoisted_205 = ["value"]
const _hoisted_206 = { class: "col-md-12 col-12" }
const _hoisted_207 = { class: "form-group" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Payment Type", -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select type", -1))
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "single" }, "Single - One Off", -1))
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "recurring" }, "Recurring", -1))
const _hoisted_212 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_213 = { class: "form-group" }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name of receiving bank", -1))
const _hoisted_215 = {
  key: 1,
  class: "col-md-12 col-12"
}
const _hoisted_216 = { class: "form-group" }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Address of receiving bank", -1))
const _hoisted_218 = {
  key: 2,
  class: "col-md-12 col-12"
}
const _hoisted_219 = { class: "form-group" }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Receiving bank SWIFT code", -1))
const _hoisted_221 = {
  key: 3,
  class: "col-md-12 col-12"
}
const _hoisted_222 = { class: "form-group" }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Receiving account name", -1))
const _hoisted_224 = {
  key: 4,
  class: "col-md-12 col-12"
}
const _hoisted_225 = { class: "form-group" }
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Receiving bank account number", -1))
const _hoisted_227 = {
  key: 5,
  class: "col-md-12 col-12"
}
const _hoisted_228 = { class: "form-group" }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Beneficiary reference number", -1))
const _hoisted_230 = {
  key: 6,
  class: "col-md-12 col-12"
}
const _hoisted_231 = { class: "form-group" }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Your reference number", -1))
const _hoisted_233 = {
  key: 7,
  class: "col-md-12 col-12"
}
const _hoisted_234 = { class: "form-group" }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Transmission Type", -1))
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select type", -1))
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "swift_mt103" }, "SWIFT MT103", -1))
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "rtgs" }, "RTGS", -1))
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "swift_gpi" }, "SWIFT GPI", -1))
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bank_draft" }, "Bank Draft", -1))
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "sblc_bg" }, "SBLC/BG", -1))
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "dlc" }, "DLC", -1))
const _hoisted_243 = {
  key: 8,
  class: "col-md-12 col-12"
}
const _hoisted_244 = { class: "form-group" }
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Receiving bank officer name", -1))
const _hoisted_246 = {
  key: 9,
  class: "col-md-12 col-12"
}
const _hoisted_247 = { class: "form-group" }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Receiving bank officer phone number", -1))
const _hoisted_249 = {
  key: 10,
  class: "col-md-12 col-12"
}
const _hoisted_250 = { class: "form-group" }
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Receiving bank officer email address", -1))
const _hoisted_252 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_253 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_254 = { class: "col-3 px-1" }
const _hoisted_255 = { class: "col-3 px-1" }
const _hoisted_256 = { class: "col-3 px-1" }
const _hoisted_257 = { class: "row my-3 justify-content-center" }
const _hoisted_258 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_259 = { class: "login-card" }
const _hoisted_260 = { class: "login-body personal" }
const _hoisted_261 = { class: "row mt-3" }
const _hoisted_262 = { class: "col-md-12 col-12" }
const _hoisted_263 = { class: "form-group" }
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name of Account Holder", -1))
const _hoisted_265 = { class: "col-md-12 col-12" }
const _hoisted_266 = { class: "form-group" }
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email Address of Caprock Account Holder", -1))
const _hoisted_268 = { class: "col-md-12 col-12" }
const _hoisted_269 = { class: "form-group" }
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number of Caprock Account Holder", -1))
const _hoisted_271 = { class: "col-md-12 col-12" }
const _hoisted_272 = { class: "form-group" }
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Date of Birth", -1))
const _hoisted_274 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_275 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_276 = { class: "col-3 px-1" }
const _hoisted_277 = { class: "col-3 px-1" }
const _hoisted_278 = { class: "col-3 px-1" }
const _hoisted_279 = { class: "row my-3 justify-content-center" }
const _hoisted_280 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_281 = { class: "login-card" }
const _hoisted_282 = { class: "login-body personal" }
const _hoisted_283 = { class: "row mt-3" }
const _hoisted_284 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_285 = { class: "form-group" }
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Certified Copy Colour Passport of Beneficiary (Included) ?", -1))
const _hoisted_287 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "colorPass0"
}, " Yes ", -1))
const _hoisted_289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "colorPass1"
}, " No ", -1))
const _hoisted_290 = {
  key: 0,
  class: "form-group"
}
const _hoisted_291 = ["innerHTML"]
const _hoisted_292 = {
  key: 3,
  class: "progress"
}
const _hoisted_293 = ["aria-valuenow"]
const _hoisted_294 = { class: "col-md-12 col-12" }
const _hoisted_295 = { class: "form-group" }
const _hoisted_296 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Certified Copy Utility Bill Showing Proof of Residential Address of Beneficiary (Included?)", -1))
const _hoisted_297 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "resiProof0"
}, " Yes ", -1))
const _hoisted_299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "resiProof1"
}, " No ", -1))
const _hoisted_300 = {
  key: 0,
  class: "form-group"
}
const _hoisted_301 = ["innerHTML"]
const _hoisted_302 = {
  key: 3,
  class: "progress"
}
const _hoisted_303 = ["aria-valuenow"]
const _hoisted_304 = { class: "col-md-12 col-12" }
const _hoisted_305 = { class: "form-group" }
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Copy of contract or invoice between Caprock Account Holder and Beneficiary as proof of transaction (Included) ?", -1))
const _hoisted_307 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_308 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "contract_proof0"
}, " Yes ", -1))
const _hoisted_309 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "contract_proof1"
}, " No ", -1))
const _hoisted_310 = {
  key: 0,
  class: "form-group"
}
const _hoisted_311 = ["innerHTML"]
const _hoisted_312 = {
  key: 3,
  class: "progress"
}
const _hoisted_313 = ["aria-valuenow"]
const _hoisted_314 = {
  key: 1,
  class: "col-md-12 col-12"
}
const _hoisted_315 = { class: "form-group" }
const _hoisted_316 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Certified Certificate of Incorporation from Beneficiary (Included) ?", -1))
const _hoisted_317 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_318 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "incorporation_certi0"
}, " Yes ", -1))
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "incorporation_certi1"
}, " No ", -1))
const _hoisted_320 = {
  key: 0,
  class: "form-group"
}
const _hoisted_321 = ["innerHTML"]
const _hoisted_322 = {
  key: 3,
  class: "progress"
}
const _hoisted_323 = ["aria-valuenow"]
const _hoisted_324 = {
  key: 2,
  class: "col-md-12 col-12"
}
const _hoisted_325 = { class: "form-group" }
const _hoisted_326 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Certified Copy of Drivers License of Beneficiary (Included) ?", -1))
const _hoisted_327 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "driver_license0"
}, " Yes ", -1))
const _hoisted_329 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "driver_license1"
}, " No ", -1))
const _hoisted_330 = {
  key: 0,
  class: "form-group"
}
const _hoisted_331 = ["innerHTML"]
const _hoisted_332 = {
  key: 3,
  class: "progress"
}
const _hoisted_333 = ["aria-valuenow"]
const _hoisted_334 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_335 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_336 = { class: "col-3 px-1" }
const _hoisted_337 = { class: "col-3 px-1" }
const _hoisted_338 = { class: "col-3 px-1" }
const _hoisted_339 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade receiving_email",
  id: "receiving_email",
  role: "dialog"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-sm modal-dialog-centered",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content bg-light" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row mx-1 mt-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
            /*#__PURE__*/_createElementVNode("p", null, "Receiving document to your mail ! Please Wait.....")
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_340 = {
  class: "modal fade cancel_request",
  id: "cancel_request",
  role: "dialog"
}
const _hoisted_341 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_342 = { class: "modal-content" }
const _hoisted_343 = { class: "modal-body mb-2" }
const _hoisted_344 = { class: "row mx-1 mt-1" }
const _hoisted_345 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Cancelling will delete all details entered.")
], -1))
const _hoisted_346 = { class: "col-md-12 text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_select2 = _resolveComponent("select2")!
  const _component_beneficiary = _resolveComponent("beneficiary")!
  const _component_toasti = _resolveComponent("toasti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.set_step(1);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='account'}])
                      }, _hoisted_14, 2),
                      _createElementVNode("li", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.set_step(2);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='beneficiary'}])
                      }, _hoisted_16, 2),
                      _createElementVNode("li", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.set_step(3);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='payment_details'}])
                      }, _hoisted_18, 2),
                      _createElementVNode("li", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.set_step(4);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='e_signature'}])
                      }, _hoisted_20, 2),
                      (_ctx.final_step==5)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.set_step(5);}),
                            class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='upload'}])
                          }, _hoisted_22, 2))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (this.current_step==1)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 0,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_1
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_Field, {
                                  modelValue: this.active_tab,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.active_tab) = $event)),
                                  name: "user_type",
                                  id: "user_type",
                                  type: "hidden"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _hoisted_30,
                                    _createVNode(_component_Field, {
                                      readonly: "",
                                      modelValue: _ctx.user_info['user_name'],
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user_info['user_name']) = $event)),
                                      placeholder: "ie. John",
                                      class: "form-control selected-field",
                                      name: "user_name",
                                      id: "user_name",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "user_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _hoisted_33,
                                    _createVNode(_component_Field, {
                                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateSubAc($event))),
                                      modelValue: _ctx.form.ac_id,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.ac_id) = $event)),
                                      class: "form-control",
                                      name: "ac_id",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_34,
                                        _hoisted_35,
                                        _hoisted_36
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "ac_id"
                                    })
                                  ])
                                ]),
                                (_ctx.form.ac_id==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      _createElementVNode("div", _hoisted_38, [
                                        _hoisted_39,
                                        _createVNode(_component_Field, {
                                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateRefNo($event))),
                                          modelValue: _ctx.form.cashac_id,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.cashac_id) = $event)),
                                          class: "form-control",
                                          name: "cashac_id",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_40,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cash_accounts, (cash) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                ref_no: cash.subac_reference_code,
                                                key: cash.subac_id,
                                                value: cash.subac_id
                                              }, _toDisplayString(cash.subac_name), 9, _hoisted_41))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "cashac_id"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.ac_id==3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      _createElementVNode("div", _hoisted_43, [
                                        _hoisted_44,
                                        _createVNode(_component_Field, {
                                          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateRefNo($event))),
                                          modelValue: _ctx.form.cashac_id,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.cashac_id) = $event)),
                                          class: "form-control",
                                          name: "cashac_id",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_45,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.securities_accounts, (security) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                ref_no: security.subac_reference_code,
                                                key: security.subac_id,
                                                value: security.subac_id
                                              }, _toDisplayString(security.subac_name), 9, _hoisted_46))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "cashac_id"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _hoisted_49,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.ac_ref_code,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.ac_ref_code) = $event)),
                                      placeholder: "ie. 265995+95",
                                      class: "form-control selected-field",
                                      name: "ac_ref_code",
                                      id: "ac_ref_code",
                                      readonly: "",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "ac_ref_code"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _hoisted_52,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.payment_reason,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.payment_reason) = $event)),
                                      class: "form-control",
                                      name: "payment_reason",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_53,
                                        _hoisted_54,
                                        _hoisted_55,
                                        _hoisted_56,
                                        _hoisted_57
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "payment_reason"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("div", _hoisted_59, [
                                    _hoisted_60,
                                    (typeof _ctx.records.trans_proof_url!='undefined' && _ctx.records.trans_proof_url!='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 0,
                                          onChange: _cache[15] || (_cache[15] = ($event: any) => {_ctx.onFileChange_s1($event);_ctx.fetch_file($event);}),
                                          modelValue: _ctx.form.trans_proof,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.trans_proof) = $event)),
                                          class: "form-control selected-field",
                                          name: "trans_proof",
                                          type: "file"
                                        }, null, 8, ["modelValue"]))
                                      : _createCommentVNode("", true),
                                    (typeof _ctx.records.trans_proof_url=='undefined' || _ctx.records.trans_proof_url=='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 1,
                                          onChange: _cache[17] || (_cache[17] = ($event: any) => {_ctx.onFileChange_s1($event);_ctx.fetch_file($event);}),
                                          modelValue: _ctx.form.trans_proof,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.trans_proof) = $event)),
                                          class: "form-control selected-field",
                                          name: "trans_proof",
                                          type: "file",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "trans_proof"
                                    }),
                                    _hoisted_61,
                                    _createElementVNode("img", {
                                      class: "p-cursor",
                                      src: _ctx.s1_image_url,
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.openDoc(_ctx.s1_image_url);}),
                                      onError: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.s1LoadError && _ctx.s1LoadError(...args))),
                                      style: {"height":"auto","width":"200px"}
                                    }, null, 40, _hoisted_62),
                                    (_ctx.s1_image_url=='' || _ctx.s1_not_image==1)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: "p-cursor",
                                          onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.openDoc(_ctx.s1_doc_url);})
                                        }, [
                                          _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_63),
                                          _hoisted_64,
                                          _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.file_s1_name), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("button", {
                                onClick: _cache[23] || (_cache[23] = ($event: any) => {_ctx.next_step=1;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _createElementVNode("button", {
                                onClick: _cache[24] || (_cache[24] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==2)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 1,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                _createElementVNode("div", _hoisted_76, [
                                  _createElementVNode("div", _hoisted_77, [
                                    _hoisted_78,
                                    _createVNode(_component_Field, {
                                      onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.set_final_step($event))),
                                      modelValue: _ctx.form.beneficiary_type,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.beneficiary_type) = $event)),
                                      class: "form-control",
                                      name: "beneficiary_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_79,
                                        _hoisted_80,
                                        _hoisted_81,
                                        _hoisted_82
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_type"
                                    })
                                  ])
                                ]),
                                (_ctx.form.beneficiary_type=='existing')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                      _createElementVNode("div", _hoisted_84, [
                                        _createElementVNode("label", _hoisted_85, [
                                          _createTextVNode(" Beneficiary "),
                                          _createElementVNode("span", {
                                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.view_beneficiary())),
                                            class: "align-items-center p-cursor"
                                          }, [
                                            (_openBlock(), _createElementBlock("svg", _hoisted_86, _hoisted_89)),
                                            _hoisted_90
                                          ])
                                        ]),
                                        _createVNode(_component_select2, {
                                          class: _normalizeClass('select2'),
                                          value: _ctx.form.beneficiary_id,
                                          modelValue: _ctx.form.beneficiary_id,
                                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.beneficiary_id) = $event)),
                                          name: "beneficiary_id",
                                          options: _ctx.beneficiary,
                                          settings: { settingOption: _ctx.key, settingOption: _ctx.value }
                                        }, null, 8, ["value", "modelValue", "options", "settings"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_id"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='own')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                      _createElementVNode("div", _hoisted_92, [
                                        _hoisted_93,
                                        _createVNode(_component_select2, {
                                          class: _normalizeClass('select2'),
                                          value: _ctx.form.bank_id,
                                          modelValue: _ctx.form.bank_id,
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.bank_id) = $event)),
                                          name: "bank_id",
                                          options: _ctx.banks,
                                          rules: _ctx.selectField,
                                          settings: { settingOption: _ctx.key, settingOption: _ctx.value }
                                        }, null, 8, ["value", "modelValue", "options", "rules", "settings"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "bank_id"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                      _createElementVNode("div", _hoisted_95, [
                                        _hoisted_96,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_user_type,
                                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.beneficiary_user_type) = $event)),
                                          class: "form-control",
                                          name: "beneficiary_user_type",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_97,
                                            _hoisted_98,
                                            _hoisted_99
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_user_type"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new'  && _ctx.form.beneficiary_user_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                      _createElementVNode("div", _hoisted_101, [
                                        _hoisted_102,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_name,
                                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.beneficiary_name) = $event)),
                                          placeholder: "i.e. Jonaten ",
                                          class: "form-control selected-field",
                                          name: "beneficiary_name",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new' && _ctx.form.beneficiary_user_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                      _createElementVNode("div", _hoisted_104, [
                                        _hoisted_105,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_company_reg_no,
                                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.beneficiary_company_reg_no) = $event)),
                                          placeholder: "i.e. IT56789 ",
                                          class: "form-control selected-field",
                                          name: "beneficiary_company_reg_no",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_company_reg_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new' && _ctx.form.beneficiary_user_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                      _createElementVNode("div", _hoisted_107, [
                                        _hoisted_108,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_nationality,
                                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.beneficiary_nationality) = $event)),
                                          class: "form-control",
                                          name: "beneficiary_nationality",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_109,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: country.country_id,
                                                value: country.country_id
                                              }, _toDisplayString(country.country_name), 9, _hoisted_110))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_nationality"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new' && _ctx.form.beneficiary_user_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                      _createElementVNode("div", _hoisted_112, [
                                        _hoisted_113,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_reg_country,
                                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.beneficiary_reg_country) = $event)),
                                          class: "form-control",
                                          name: "beneficiary_reg_country",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_114,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: country.country_id,
                                                value: country.country_id
                                              }, _toDisplayString(country.country_name), 9, _hoisted_115))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_reg_country"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                      _createElementVNode("div", _hoisted_117, [
                                        _hoisted_118,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_structure,
                                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.beneficiary_structure) = $event)),
                                          class: "form-control",
                                          name: "beneficiary_structure",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_119,
                                            _hoisted_120,
                                            _hoisted_121,
                                            _hoisted_122,
                                            _hoisted_123
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_structure"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new'  && _ctx.form.beneficiary_user_type=='individual')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                      _createElementVNode("div", _hoisted_125, [
                                        _hoisted_126,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_name,
                                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.beneficiary_name) = $event)),
                                          placeholder: "i.e. Jonaten ",
                                          class: "form-control selected-field",
                                          name: "beneficiary_name",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                      _createElementVNode("div", _hoisted_128, [
                                        _hoisted_129,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_passport_no,
                                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.beneficiary_passport_no) = $event)),
                                          placeholder: "i.e. L8989S446546 ",
                                          class: "form-control selected-field",
                                          name: "beneficiary_passport_no",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_passport_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                      _createElementVNode("div", _hoisted_131, [
                                        _hoisted_132,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_passport_expiry,
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.beneficiary_passport_expiry) = $event)),
                                          class: "form-control selected-field",
                                          name: "beneficiary_passport_expiry",
                                          type: "date",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_passport_expiry"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                      _createElementVNode("div", _hoisted_134, [
                                        _hoisted_135,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_passport_country,
                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.beneficiary_passport_country) = $event)),
                                          class: "form-control",
                                          name: "beneficiary_passport_country",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_136,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: country.country_id,
                                                value: country.country_id
                                              }, _toDisplayString(country.country_name), 9, _hoisted_137))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_passport_country"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                      _createElementVNode("div", _hoisted_139, [
                                        _hoisted_140,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_dob,
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.beneficiary_dob) = $event)),
                                          class: "form-control selected-field",
                                          name: "beneficiary_dob",
                                          type: "date",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_dob"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                      _createElementVNode("div", _hoisted_142, [
                                        _hoisted_143,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[41] || (_cache[41] = ($event: any) => {_ctx.textSearch($event);}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.beneficiary_home_address,
                                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.beneficiary_home_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "beneficiary_home_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_home_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_144, [
                                        _createElementVNode("div", _hoisted_145, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id);},
                                              class: "suggestDiv"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_147),
                                              _createElementVNode("h6", _hoisted_148, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_149, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_146))
                                          }), 128)),
                                          _hoisted_150
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                      _createElementVNode("div", _hoisted_152, [
                                        _hoisted_153,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_email_id,
                                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.beneficiary_email_id) = $event)),
                                          class: "form-control selected-field",
                                          name: "beneficiary_email_id",
                                          type: "text",
                                          rules: [_ctx.requiredField,_ctx.validateEmail]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_email_id"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                      _createElementVNode("div", _hoisted_155, [
                                        _hoisted_156,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_phone_no,
                                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.beneficiary_phone_no) = $event)),
                                          class: "form-control selected-field",
                                          name: "beneficiary_phone_no",
                                          type: "text",
                                          rules: [_ctx.requiredField,_ctx.mobileField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_phone_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                      _createElementVNode("div", _hoisted_158, [
                                        _hoisted_159,
                                        _createTextVNode(),
                                        _hoisted_160,
                                        _createVNode(_component_Field, {
                                          id: "beneficiary_trust0",
                                          modelValue: _ctx.form.beneficiary_trust,
                                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.beneficiary_trust) = $event)),
                                          class: "mx-2",
                                          name: "beneficiary_trust",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_161,
                                        _createVNode(_component_Field, {
                                          id: "beneficiary_trust1",
                                          modelValue: _ctx.form.beneficiary_trust,
                                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.form.beneficiary_trust) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "beneficiary_trust",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_162,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_trust"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new' &&  _ctx.form.beneficiary_trust==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                      _createElementVNode("div", _hoisted_164, [
                                        _hoisted_165,
                                        (typeof _ctx.records.trust_deed_url!='undefined' && _ctx.records.trust_deed_url!='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 0,
                                              onChange: _cache[47] || (_cache[47] = ($event: any) => {_ctx.onFileChange_s2($event);_ctx.fetch_file($event);}),
                                              class: "form-control selected-field",
                                              name: "trust_deed",
                                              type: "file"
                                            }))
                                          : _createCommentVNode("", true),
                                        (typeof _ctx.records.trust_deed_url=='undefined' || _ctx.records.trust_deed_url=='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 1,
                                              onChange: _cache[48] || (_cache[48] = ($event: any) => {_ctx.onFileChange_s2($event);_ctx.fetch_file($event);}),
                                              class: "form-control selected-field",
                                              name: "trust_deed",
                                              type: "file",
                                              rules: _ctx.requiredField
                                            }, null, 8, ["rules"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "trust_deed"
                                        }),
                                        _createElementVNode("img", {
                                          class: "p-cursor",
                                          src: _ctx.s2_image_url,
                                          onClick: _cache[49] || (_cache[49] = ($event: any) => {_ctx.openDoc(_ctx.s2_image_url);}),
                                          onError: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.s2LoadError && _ctx.s2LoadError(...args))),
                                          style: {"height":"auto","width":"200px"}
                                        }, null, 40, _hoisted_166),
                                        (_ctx.s2_image_url=='' || _ctx.s2_not_image==1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: "p-cursor",
                                              onClick: _cache[51] || (_cache[51] = ($event: any) => {_ctx.openDoc(_ctx.s2_doc_url);})
                                            }, [
                                              _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_167),
                                              _hoisted_168,
                                              _createElementVNode("p", _hoisted_169, _toDisplayString(_ctx.file_s2_name), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                      _createElementVNode("div", _hoisted_171, [
                                        _hoisted_172,
                                        _createTextVNode(),
                                        _hoisted_173,
                                        _createVNode(_component_Field, {
                                          id: "usa_citizen0",
                                          modelValue: _ctx.form.beneficiary_usa_citizen,
                                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.beneficiary_usa_citizen) = $event)),
                                          class: "mx-2",
                                          name: "beneficiary_usa_citizen",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_174,
                                        _createVNode(_component_Field, {
                                          id: "usa_citizen1",
                                          modelValue: _ctx.form.beneficiary_usa_citizen,
                                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.form.beneficiary_usa_citizen) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "beneficiary_usa_citizen",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_175,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_usa_citizen"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new' && (_ctx.form.beneficiary_usa_citizen==1 || _ctx.form.beneficiary_tax_resident_usa==1))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                      _createElementVNode("div", _hoisted_177, [
                                        _hoisted_178,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_social_security_no,
                                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.beneficiary_social_security_no) = $event)),
                                          class: "form-control selected-field",
                                          name: "beneficiary_social_security_no",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_social_security_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                      _createElementVNode("div", _hoisted_180, [
                                        _hoisted_181,
                                        _createTextVNode(),
                                        _hoisted_182,
                                        _createVNode(_component_Field, {
                                          id: "beneficiary_tax_resident_usa0",
                                          modelValue: _ctx.form.beneficiary_tax_resident_usa,
                                          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.form.beneficiary_tax_resident_usa) = $event)),
                                          class: "mx-2",
                                          name: "beneficiary_tax_resident_usa",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_183,
                                        _createVNode(_component_Field, {
                                          id: "beneficiary_tax_resident_usa1",
                                          modelValue: _ctx.form.beneficiary_tax_resident_usa,
                                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.form.beneficiary_tax_resident_usa) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "beneficiary_tax_resident_usa",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_184,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_tax_resident_usa"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new' && _ctx.form.beneficiary_tax_resident_usa==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                      _createElementVNode("div", _hoisted_186, [
                                        _hoisted_187,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_tax_id,
                                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.form.beneficiary_tax_id) = $event)),
                                          class: "form-control selected-field",
                                          name: "beneficiary_tax_id",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_tax_id"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_188, [
                          _createElementVNode("div", _hoisted_189, [
                            _createElementVNode("div", _hoisted_190, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_191, [
                              _createElementVNode("button", {
                                onClick: _cache[59] || (_cache[59] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_192, [
                              _createElementVNode("button", {
                                onClick: _cache[60] || (_cache[60] = ($event: any) => {_ctx.next_step=3;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 2,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_193, [
                        _createElementVNode("div", _hoisted_194, [
                          _createElementVNode("div", _hoisted_195, [
                            _createElementVNode("div", _hoisted_196, [
                              _createElementVNode("div", _hoisted_197, [
                                _createElementVNode("div", _hoisted_198, [
                                  _createElementVNode("div", _hoisted_199, [
                                    _hoisted_200,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.payment_amount,
                                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.form.payment_amount) = $event)),
                                      placeholder: "i.e. 50000 ",
                                      class: "form-control selected-field",
                                      name: "payment_amount",
                                      type: "number",
                                      step: "any",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "payment_amount"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_201, [
                                  _createElementVNode("div", _hoisted_202, [
                                    _hoisted_203,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.payment_currency,
                                      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.form.payment_currency) = $event)),
                                      class: "form-control",
                                      name: "payment_currency",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_204,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, (currency) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: currency.currency_id,
                                            value: currency.currency_id
                                          }, _toDisplayString(currency.currency_symbol) + " " + _toDisplayString(currency.currency_name), 9, _hoisted_205))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "payment_currency"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_206, [
                                  _createElementVNode("div", _hoisted_207, [
                                    _hoisted_208,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.payment_type,
                                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.form.payment_type) = $event)),
                                      class: "form-control",
                                      name: "payment_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_209,
                                        _hoisted_210,
                                        _hoisted_211
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "payment_type"
                                    })
                                  ])
                                ]),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                      _createElementVNode("div", _hoisted_213, [
                                        _hoisted_214,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.bank_name,
                                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.form.bank_name) = $event)),
                                          placeholder: "i.e. CITI Bank ",
                                          class: "form-control selected-field",
                                          name: "bank_name",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "bank_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
                                      _createElementVNode("div", _hoisted_216, [
                                        _hoisted_217,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.bank_address,
                                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.form.bank_address) = $event)),
                                          placeholder: "i.e. Sea Link,  Sydney",
                                          class: "form-control selected-field",
                                          name: "bank_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "bank_address"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                                      _createElementVNode("div", _hoisted_219, [
                                        _hoisted_220,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.bank_swift_code,
                                          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.form.bank_swift_code) = $event)),
                                          placeholder: "i.e. JJDH546",
                                          class: "form-control selected-field",
                                          name: "bank_swift_code",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "bank_swift_code"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                                      _createElementVNode("div", _hoisted_222, [
                                        _hoisted_223,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.bank_ac_name,
                                          "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.form.bank_ac_name) = $event)),
                                          placeholder: "i.e. Jonaten ",
                                          class: "form-control selected-field",
                                          name: "bank_ac_name",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "bank_ac_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                      _createElementVNode("div", _hoisted_225, [
                                        _hoisted_226,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.bank_ac_no,
                                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.form.bank_ac_no) = $event)),
                                          placeholder: "i.e. 3539 000556  ",
                                          class: "form-control selected-field",
                                          name: "bank_ac_no",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "bank_ac_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                                      _createElementVNode("div", _hoisted_228, [
                                        _hoisted_229,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.beneficiary_ref_no,
                                          "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.form.beneficiary_ref_no) = $event)),
                                          placeholder: "i.e. IG987982  ",
                                          class: "form-control selected-field",
                                          name: "beneficiary_ref_no",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_ref_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                                      _createElementVNode("div", _hoisted_231, [
                                        _hoisted_232,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.your_ref_no,
                                          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.form.your_ref_no) = $event)),
                                          placeholder: "i.e. IG987982  ",
                                          class: "form-control selected-field",
                                          name: "your_ref_no",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "your_ref_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_233, [
                                      _createElementVNode("div", _hoisted_234, [
                                        _hoisted_235,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.payment_transmission_type,
                                          "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.form.payment_transmission_type) = $event)),
                                          class: "form-control",
                                          name: "payment_transmission_type",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_236,
                                            _hoisted_237,
                                            _hoisted_238,
                                            _hoisted_239,
                                            _hoisted_240,
                                            _hoisted_241,
                                            _hoisted_242
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "payment_transmission_type"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                      _createElementVNode("div", _hoisted_244, [
                                        _hoisted_245,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.bank_officer_name,
                                          "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.form.bank_officer_name) = $event)),
                                          placeholder: "i.e. Officer name",
                                          class: "form-control selected-field",
                                          name: "bank_officer_name",
                                          type: "text"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "bank_officer_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                                      _createElementVNode("div", _hoisted_247, [
                                        _hoisted_248,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.bank_officer_phone_no,
                                          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.form.bank_officer_phone_no) = $event)),
                                          placeholder: "i.e. +4 455545665  ",
                                          class: "form-control selected-field",
                                          name: "bank_officer_phone_no",
                                          type: "text",
                                          rules: [_ctx.mobileField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "bank_officer_phone_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.beneficiary_type=='new')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_249, [
                                      _createElementVNode("div", _hoisted_250, [
                                        _hoisted_251,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.bank_officer_email_address,
                                          "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.form.bank_officer_email_address) = $event)),
                                          placeholder: "i.e. email@address.com  ",
                                          class: "form-control selected-field",
                                          name: "bank_officer_email_address",
                                          type: "text",
                                          rules: [_ctx.validateEmail]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "bank_officer_email_address"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_252, [
                          _createElementVNode("div", _hoisted_253, [
                            _createElementVNode("div", _hoisted_254, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_255, [
                              _createElementVNode("button", {
                                onClick: _cache[76] || (_cache[76] = ($event: any) => {_ctx.next_step=3;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_256, [
                              _createElementVNode("button", {
                                onClick: _cache[77] || (_cache[77] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==4)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 3,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_257, [
                        _createElementVNode("div", _hoisted_258, [
                          _createElementVNode("div", _hoisted_259, [
                            _createElementVNode("div", _hoisted_260, [
                              _createElementVNode("div", _hoisted_261, [
                                _createElementVNode("div", _hoisted_262, [
                                  _createElementVNode("div", _hoisted_263, [
                                    _hoisted_264,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_name,
                                      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.form.esign_name) = $event)),
                                      placeholder: "i.e. Jonaten ",
                                      class: "form-control selected-field",
                                      name: "esign_name",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_265, [
                                  _createElementVNode("div", _hoisted_266, [
                                    _hoisted_267,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_email_id,
                                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.form.esign_email_id) = $event)),
                                      placeholder: "i.e. email@address.com  ",
                                      class: "form-control selected-field",
                                      name: "esign_email_id",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.validateEmail]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_email_id"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_268, [
                                  _createElementVNode("div", _hoisted_269, [
                                    _hoisted_270,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_phone_no,
                                      "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.form.esign_phone_no) = $event)),
                                      placeholder: "i.e. 3539 000556  ",
                                      class: "form-control selected-field",
                                      name: "esign_phone_no",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.mobileField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_phone_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_271, [
                                  _createElementVNode("div", _hoisted_272, [
                                    _hoisted_273,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_dob,
                                      "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.form.esign_dob) = $event)),
                                      class: "form-control selected-field",
                                      name: "esign_dob",
                                      type: "date",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_dob"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_274, [
                          _createElementVNode("div", _hoisted_275, [
                            _createElementVNode("div", _hoisted_276, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_277, [
                              _createElementVNode("button", {
                                onClick: _cache[83] || (_cache[83] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_278, [
                              (this.final_step==4)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[84] || (_cache[84] = ($event: any) => {_ctx.next_step=200;}),
                                    type: "submit",
                                    class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                                  }, " Save & Next "))
                                : _createCommentVNode("", true),
                              (this.final_step==5)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    onClick: _cache[85] || (_cache[85] = ($event: any) => {_ctx.next_step=5;}),
                                    type: "submit",
                                    class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                                  }, " Save & Next "))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==5 && _ctx.final_step==5)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 4,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_279, [
                        _createElementVNode("div", _hoisted_280, [
                          _createElementVNode("div", _hoisted_281, [
                            _createElementVNode("div", _hoisted_282, [
                              _createElementVNode("div", _hoisted_283, [
                                (_ctx.form.is_driver_license!=1 && _ctx.form.is_driver_license!='1')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_284, [
                                      _createElementVNode("div", _hoisted_285, [
                                        _hoisted_286,
                                        _createTextVNode(),
                                        _hoisted_287,
                                        _createVNode(_component_Field, {
                                          id: "colorPass0",
                                          modelValue: _ctx.form.is_colour_passport,
                                          "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.form.is_colour_passport) = $event)),
                                          class: "mx-2",
                                          name: "is_colour_passport",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_288,
                                        _createVNode(_component_Field, {
                                          id: "colorPass1",
                                          modelValue: _ctx.form.is_colour_passport,
                                          "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.form.is_colour_passport) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_colour_passport",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_289,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_colour_passport"
                                        })
                                      ]),
                                      (_ctx.form.is_colour_passport==1 || _ctx.form.is_colour_passport=='1')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_290, [
                                            (typeof _ctx.records.colour_passport_url!='undefined' && _ctx.records.colour_passport_url!='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 0,
                                                  onChange: _cache[88] || (_cache[88] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.form.colour_passport,
                                                  "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.form.colour_passport) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "colour_passport",
                                                  type: "file"
                                                }, null, 8, ["modelValue"]))
                                              : _createCommentVNode("", true),
                                            (typeof _ctx.records.colour_passport_url=='undefined' || _ctx.records.colour_passport_url=='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 1,
                                                  onChange: _cache[90] || (_cache[90] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.form.colour_passport,
                                                  "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.form.colour_passport) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "colour_passport",
                                                  type: "file",
                                                  rules: _ctx.requiredField
                                                }, null, 8, ["modelValue", "rules"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "colour_passport"
                                            }),
                                            (typeof _ctx.records.colour_passport_url!='undefined' && _ctx.records.colour_passport_url!='')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 2,
                                                  class: "p-cursor",
                                                  onClick: _cache[92] || (_cache[92] = ($event: any) => {_ctx.openDoc(_ctx.records.colour_passport_url);})
                                                }, [
                                                  _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_291),
                                                  _createTextVNode(" Colour Passport ")
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.form.colour_passport_pdiv==1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_292, [
                                                  _createElementVNode("div", {
                                                    class: "progress-bar bg-dark",
                                                    role: "progressbar",
                                                    style: _normalizeStyle({'width':_ctx.form.colour_passport_pbar+'%'}),
                                                    "aria-valuenow": _ctx.form.colour_passport_pbar,
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100"
                                                  }, _toDisplayString(_ctx.form.colour_passport_pbar_p), 13, _hoisted_293)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_Field, {
                                              rules: _ctx.requiredField,
                                              modelValue: _ctx.form.colour_passport_path,
                                              "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.form.colour_passport_path) = $event)),
                                              class: "form-control selected-field",
                                              name: "colour_passport_path",
                                              type: "hidden"
                                            }, null, 8, ["rules", "modelValue"]),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "colour_passport_path"
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_294, [
                                  _createElementVNode("div", _hoisted_295, [
                                    _hoisted_296,
                                    _createTextVNode(),
                                    _hoisted_297,
                                    _createVNode(_component_Field, {
                                      id: "resiProof0",
                                      modelValue: _ctx.form.is_residence_proof,
                                      "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.form.is_residence_proof) = $event)),
                                      class: "mx-2",
                                      name: "is_residence_proof",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "1"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_298,
                                    _createVNode(_component_Field, {
                                      id: "resiProof1",
                                      modelValue: _ctx.form.is_residence_proof,
                                      "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.form.is_residence_proof) = $event)),
                                      class: "ml-4 mx-2",
                                      name: "is_residence_proof",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "0"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_299,
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "is_residence_proof"
                                    })
                                  ]),
                                  (_ctx.form.is_residence_proof==1 || _ctx.form.is_residence_proof=='1')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_300, [
                                        (typeof _ctx.records.residence_proof_url!='undefined' && _ctx.records.residence_proof_url!='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 0,
                                              onChange: _cache[96] || (_cache[96] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.form.residence_proof,
                                              "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.form.residence_proof) = $event)),
                                              class: "form-control selected-field",
                                              name: "residence_proof",
                                              type: "file"
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true),
                                        (typeof _ctx.records.residence_proof_url=='undefined' || _ctx.records.residence_proof_url=='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 1,
                                              onChange: _cache[98] || (_cache[98] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.form.residence_proof,
                                              "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.form.residence_proof) = $event)),
                                              class: "form-control selected-field",
                                              name: "residence_proof",
                                              type: "file",
                                              rules: _ctx.requiredField
                                            }, null, 8, ["modelValue", "rules"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "residence_proof"
                                        }),
                                        (typeof _ctx.records.residence_proof_url!='undefined' && _ctx.records.residence_proof_url!='')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: "p-cursor",
                                              onClick: _cache[100] || (_cache[100] = ($event: any) => {_ctx.openDoc(_ctx.records.residence_proof_url);})
                                            }, [
                                              _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_301),
                                              _createTextVNode(" Residence Proof ")
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.form.residence_proof_pdiv==1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                                              _createElementVNode("div", {
                                                class: "progress-bar bg-dark",
                                                role: "progressbar",
                                                style: _normalizeStyle({'width':_ctx.form.residence_proof_pbar+'%'}),
                                                "aria-valuenow": _ctx.form.residence_proof_pbar,
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }, _toDisplayString(_ctx.form.residence_proof_pbar_p), 13, _hoisted_303)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_Field, {
                                          rules: _ctx.requiredField,
                                          modelValue: _ctx.form.residence_proof_path,
                                          "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.form.residence_proof_path) = $event)),
                                          class: "form-control selected-field",
                                          name: "residence_proof_path",
                                          type: "hidden"
                                        }, null, 8, ["rules", "modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "residence_proof_path"
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_304, [
                                  _createElementVNode("div", _hoisted_305, [
                                    _hoisted_306,
                                    _createTextVNode(),
                                    _hoisted_307,
                                    _createVNode(_component_Field, {
                                      id: "contract_proof0",
                                      modelValue: _ctx.form.is_contract_proof,
                                      "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.form.is_contract_proof) = $event)),
                                      class: "mx-2",
                                      name: "is_contract_proof",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "1"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_308,
                                    _createVNode(_component_Field, {
                                      id: "contract_proof1",
                                      modelValue: _ctx.form.is_contract_proof,
                                      "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.form.is_contract_proof) = $event)),
                                      class: "ml-4 mx-2",
                                      name: "is_contract_proof",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "0"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_309,
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "is_contract_proof"
                                    })
                                  ]),
                                  (_ctx.form.is_contract_proof==1 || _ctx.form.is_contract_proof=='1')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_310, [
                                        (typeof _ctx.records.contract_proof_url!='undefined' && _ctx.records.contract_proof_url!='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 0,
                                              onChange: _cache[104] || (_cache[104] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.form.contract_proof,
                                              "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ((_ctx.form.contract_proof) = $event)),
                                              class: "form-control selected-field",
                                              name: "contract_proof",
                                              type: "file"
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true),
                                        (typeof _ctx.records.contract_proof_url=='undefined' || _ctx.records.contract_proof_url=='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 1,
                                              onChange: _cache[106] || (_cache[106] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.form.contract_proof,
                                              "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.form.contract_proof) = $event)),
                                              class: "form-control selected-field",
                                              name: "contract_proof",
                                              type: "file",
                                              rules: _ctx.requiredField
                                            }, null, 8, ["modelValue", "rules"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "contract_proof"
                                        }),
                                        (typeof _ctx.records.contract_proof_url!='undefined' && _ctx.records.contract_proof_url!='')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: "p-cursor",
                                              onClick: _cache[108] || (_cache[108] = ($event: any) => {_ctx.openDoc(_ctx.records.contract_proof_url);})
                                            }, [
                                              _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_311),
                                              _createTextVNode(" Contract Proof ")
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.form.contract_proof_pdiv==1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_312, [
                                              _createElementVNode("div", {
                                                class: "progress-bar bg-dark",
                                                role: "progressbar",
                                                style: _normalizeStyle({'width':_ctx.form.contract_proof_pbar+'%'}),
                                                "aria-valuenow": _ctx.form.contract_proof_pbar,
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }, _toDisplayString(_ctx.form.contract_proof_pbar_p), 13, _hoisted_313)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_Field, {
                                          rules: _ctx.requiredField,
                                          modelValue: _ctx.form.contract_proof_path,
                                          "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((_ctx.form.contract_proof_path) = $event)),
                                          class: "form-control selected-field",
                                          name: "contract_proof_path",
                                          type: "hidden"
                                        }, null, 8, ["rules", "modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "contract_proof_path"
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.form.beneficiary_user_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
                                      _createElementVNode("div", _hoisted_315, [
                                        _hoisted_316,
                                        _createTextVNode(),
                                        _hoisted_317,
                                        _createVNode(_component_Field, {
                                          id: "incorporation_certi0",
                                          modelValue: _ctx.form.is_incorporation_certi,
                                          "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.form.is_incorporation_certi) = $event)),
                                          class: "mx-2",
                                          name: "is_incorporation_certi",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_318,
                                        _createVNode(_component_Field, {
                                          id: "incorporation_certi1",
                                          modelValue: _ctx.form.is_incorporation_certi,
                                          "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((_ctx.form.is_incorporation_certi) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_incorporation_certi",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_319,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_incorporation_certi"
                                        })
                                      ]),
                                      (_ctx.form.is_incorporation_certi==1 || _ctx.form.is_incorporation_certi=='1')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_320, [
                                            (typeof _ctx.records.incorporation_certi_url!='undefined' && _ctx.records.incorporation_certi_url!='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 0,
                                                  onChange: _cache[112] || (_cache[112] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.form.incorporation_certi,
                                                  "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ((_ctx.form.incorporation_certi) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "incorporation_certi",
                                                  type: "file"
                                                }, null, 8, ["modelValue"]))
                                              : _createCommentVNode("", true),
                                            (typeof _ctx.records.incorporation_certi_url=='undefined' || _ctx.records.incorporation_certi_url=='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 1,
                                                  onChange: _cache[114] || (_cache[114] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.form.incorporation_certi,
                                                  "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => ((_ctx.form.incorporation_certi) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "incorporation_certi",
                                                  type: "file",
                                                  rules: _ctx.requiredField
                                                }, null, 8, ["modelValue", "rules"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "incorporation_certi"
                                            }),
                                            (typeof _ctx.records.incorporation_certi_url!='undefined' && _ctx.records.incorporation_certi_url!='')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 2,
                                                  class: "p-cursor",
                                                  onClick: _cache[116] || (_cache[116] = ($event: any) => {_ctx.openDoc(_ctx.records.incorporation_certi_url);})
                                                }, [
                                                  _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_321),
                                                  _createTextVNode(" Incorporation Certificate ")
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.form.incorporation_certi_pdiv==1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_322, [
                                                  _createElementVNode("div", {
                                                    class: "progress-bar bg-dark",
                                                    role: "progressbar",
                                                    style: _normalizeStyle({'width':_ctx.form.incorporation_certi_pbar+'%'}),
                                                    "aria-valuenow": _ctx.form.incorporation_certi_pbar,
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100"
                                                  }, _toDisplayString(_ctx.form.incorporation_certi_pbar_p), 13, _hoisted_323)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_Field, {
                                              rules: _ctx.requiredField,
                                              modelValue: _ctx.form.incorporation_certi_path,
                                              "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((_ctx.form.incorporation_certi_path) = $event)),
                                              class: "form-control selected-field",
                                              name: "incorporation_certi_path",
                                              type: "hidden"
                                            }, null, 8, ["rules", "modelValue"]),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "incorporation_certi_path"
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.is_colour_passport!=1 && _ctx.form.is_colour_passport!='1')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_324, [
                                      _createElementVNode("div", _hoisted_325, [
                                        _hoisted_326,
                                        _createTextVNode(),
                                        _hoisted_327,
                                        _createVNode(_component_Field, {
                                          id: "driver_license0",
                                          modelValue: _ctx.form.is_driver_license,
                                          "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => ((_ctx.form.is_driver_license) = $event)),
                                          class: "mx-2",
                                          name: "is_driver_license",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_328,
                                        _createVNode(_component_Field, {
                                          id: "driver_license1",
                                          modelValue: _ctx.form.is_driver_license,
                                          "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ((_ctx.form.is_driver_license) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_driver_license",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_329,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_driver_license"
                                        })
                                      ]),
                                      (_ctx.form.is_driver_license==1 || _ctx.form.is_driver_license=='1')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_330, [
                                            (typeof _ctx.records.driver_license_url!='undefined' && _ctx.records.driver_license_url!='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 0,
                                                  onChange: _cache[120] || (_cache[120] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.form.driver_license,
                                                  "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => ((_ctx.form.driver_license) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "driver_license",
                                                  type: "file"
                                                }, null, 8, ["modelValue"]))
                                              : _createCommentVNode("", true),
                                            (typeof _ctx.records.driver_license_url=='undefined' || _ctx.records.driver_license_url=='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 1,
                                                  onChange: _cache[122] || (_cache[122] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.form.driver_license,
                                                  "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => ((_ctx.form.driver_license) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "driver_license",
                                                  type: "file",
                                                  rules: _ctx.requiredField
                                                }, null, 8, ["modelValue", "rules"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "driver_license"
                                            }),
                                            (typeof _ctx.records.driver_license_url!='undefined' && _ctx.records.driver_license_url!='')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 2,
                                                  class: "p-cursor",
                                                  onClick: _cache[124] || (_cache[124] = ($event: any) => {_ctx.openDoc(_ctx.records.driver_license_url);})
                                                }, [
                                                  _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_331),
                                                  _createTextVNode(" Driver License Copy ")
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.form.driver_license_pdiv==1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_332, [
                                                  _createElementVNode("div", {
                                                    class: "progress-bar bg-dark",
                                                    role: "progressbar",
                                                    style: _normalizeStyle({'width':_ctx.form.driver_license_pbar+'%'}),
                                                    "aria-valuenow": _ctx.form.driver_license_pbar,
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100"
                                                  }, _toDisplayString(_ctx.form.driver_license_pbar_p), 13, _hoisted_333)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_Field, {
                                              rules: _ctx.requiredField,
                                              modelValue: _ctx.form.driver_license_path,
                                              "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => ((_ctx.form.driver_license_path) = $event)),
                                              class: "form-control selected-field",
                                              name: "driver_license_path",
                                              type: "hidden"
                                            }, null, 8, ["rules", "modelValue"]),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "driver_license_path"
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_334, [
                          _createElementVNode("div", _hoisted_335, [
                            _createElementVNode("div", _hoisted_336, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[126] || (_cache[126] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_337, [
                              _createElementVNode("button", {
                                onClick: _cache[127] || (_cache[127] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_338, [
                              _createElementVNode("button", {
                                onClick: _cache[128] || (_cache[128] = ($event: any) => {_ctx.next_step=200;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Finish ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_339,
    _createElementVNode("div", _hoisted_340, [
      _createElementVNode("div", _hoisted_341, [
        _createElementVNode("div", _hoisted_342, [
          _createElementVNode("div", _hoisted_343, [
            _createElementVNode("div", _hoisted_344, [
              _hoisted_345,
              _createElementVNode("div", _hoisted_346, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[129] || (_cache[129] = ($event: any) => (_ctx.cancel_request(1)))
                }, "Ok"),
                _createElementVNode("button", {
                  onClick: _cache[130] || (_cache[130] = ($event: any) => (_ctx.closeModal('cancel_request'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_beneficiary, {
      ref: "bnF",
      beneficiary_id: _ctx.beneficiary_id,
      beneficiary_on: _ctx.beneficiary_on,
      countries: _ctx.countries,
      reload_b: 0
    }, null, 8, ["beneficiary_id", "beneficiary_on", "countries"]),
    _createVNode(_component_toasti, { ref: "toasti" }, null, 512)
  ], 64))
}